import api from '../services/api';

const baseUrl = 'requests/hearing'

const save = async (requestId, data) =>
    api.post({ type: 'user', service: `${baseUrl}/${requestId}`, data });

const findByRequestId = async (requestId) =>
    api.get({ type: 'user', service: `${baseUrl}/${requestId}` });

const confirmPresence = async (requestId) =>
    api.post({ type: 'user', service: `${baseUrl}/${requestId}/confirm-presence` });

const checkIn = async (requestId, data) =>
    api.post({ type: 'user', service: `${baseUrl}/${requestId}/check-in`, data });

export default {
    save,
    findByRequestId,
    confirmPresence,
    checkIn
}